import DomainErrorTypes from './DomainErrorTypes';

export default class DomainError extends Error {
   public readonly errorType: string;

   constructor(errorType: DomainErrorTypes | string, message: string) {
     super(message)/* istanbul ignore next */;
     Object.setPrototypeOf(this, DomainError.prototype);
     Error.captureStackTrace(this, this.constructor);
     this.name = this.constructor.name;
     this.errorType = errorType;
   }

   toJSON(): object {
     return {
       name: this.name,
       message: this.message,
       errorType: this.errorType,
     };
   }
}
